export const TIMEOUT = 3 * 60000



// WEBPACK FOOTER //
// ./src/constants/timeout.ts